<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
    :key="icon"
    :class="{ 'h-full w-full': containerSize }"
  />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';
import type { Component } from 'vue';

const components: Record<string, Component> = {
  searchIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconSearch.vue'),
  ),
  userIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconUser.vue'),
  ),
  menubarIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconMenuBar.vue'),
  ),
  closeIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconClose.vue'),
  ),
  closeBoldIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconCloseBold.vue'),
  ),
  arrowRightIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconArrowRight.vue'),
  ),
  arrowUpIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconArrowUp.vue'),
  ),
  arrowRightBoldIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconArrowRightBold.vue'),
  ),
  sliderArrowLeftIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconSliderArrowLeft.vue'),
  ),
  sliderArrowRightIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconSliderArrowRight.vue'),
  ),
  chevronUpIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconChevronUp.vue'),
  ),
  chevronDownIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconChevronDown.vue'),
  ),
  chevronUpBigIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconChevronUpBig.vue'),
  ),
  chevronDownBigIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconChevronDownBig.vue'),
  ),
  chevronRightIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconChevronRight.vue'),
  ),
  chevronLeftIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconChevronLeft.vue'),
  ),
  chevronRightThinIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconChevronRightThin.vue'),
  ),
  instagramIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconInstagram.vue'),
  ),
  facebookIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconFacebook.vue'),
  ),
  twitterIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconTwitter.vue'),
  ),
  telegramIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconTelegram.vue'),
  ),
  youtubeIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconYoutube.vue'),
  ),
  linkedinIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconLinkedIn.vue'),
  ),
  logoMainIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconLogoMain.vue'),
  ),
  playIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconPlay.vue'),
  ),
  checkmarkIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconCheckmark.vue'),
  ),
  copyIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconCopy.vue'),
  ),
  quoteIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconQuote.vue'),
  ),
  pdfFileIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconPdfFile.vue'),
  ),
  downloadIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconDownload.vue'),
  ),
  filterIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconFilter.vue'),
  ),
  warningIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconWarning.vue'),
  ),
  locationIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconLocation.vue'),
  ),
  aClassIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconAClass.vue'),
  ),
  bClassIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconBClass.vue'),
  ),
  cClassIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconCClass.vue'),
  ),
  dClassIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconDClass.vue'),
  ),
  eClassIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconEClass.vue'),
  ),
  fClassIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconFClass.vue'),
  ),
  gClassIcon: defineAsyncComponent(
    () => import('@/components/icons/UiIconGClass.vue'),
  ),
};

interface Props {
  icon: string;
  containerSize?: boolean;
}

const props = defineProps<Props>();

const iconComponent = computed<Component>(
  () => components[`${props.icon}Icon`],
);
</script>
